/**
 *
 * FlexLabel
 *
 */

import React from 'react';
import styles from './styles.module.css';

import { FlexBox } from 'components/common';

import { Icon } from 'semantic-ui-react';

function FlexLabel(props) {
  const {
    style,
    flex,
    className,
    guttered,
    format,
    gutter = 10,
    vstretch,
    font,
    hstretch,
    rightGutter,
    bottomGutter,
    leftGutter,
    topGutter,
    fill,
    text,
    subtext,
    icon,
    material,
    align,
    justify,
    primary,
    secondary,
    tertiary,
    weight,
    textColor,
  } = props;

  let elemStyle = style ? { ...style } : {};
  if (rightGutter || guttered) {
    elemStyle.marginRight = `${gutter}px`;
  }

  if (bottomGutter || guttered) {
    elemStyle.marginBottom = `${gutter}px`;
  }

  if (leftGutter || guttered) {
    elemStyle.marginLeft = `${gutter}px`;
  }

  if (topGutter || guttered) {
    elemStyle.marginTop = `${gutter}px`;
  }

  if (flex) {
    elemStyle.flex = flex;
  }

  if (fill) {
    elemStyle.height = '100%';
    elemStyle.width = '100%';
  }

  if (vstretch) {
    elemStyle.height = '100%';
    elemStyle.overflowY = 'auto';
  }

  if (hstretch) {
    elemStyle.width = '100%';
  }

  if (props.nowrap) {
    elemStyle.whiteSpace = 'nowrap';
  }

  if (props.delay) {
    elemStyle.animationDelay = `${props.delay}ms`;
  }

  let classes = `${styles.flexLabel}`;

  if (props.className) {
    classes = `${props.className} ` + classes;
  }

  let textStyle = {};
  let subtextStyle = {};
  let textContentStyle = {};
  let iconStyle = {};

  if (!text && subtext) {
    subtextStyle.lineHeight = '1.0';
    subtextStyle.marginTop = '0px';
  }

  if (tertiary) {
    textStyle.color = 'var(--background-tertiary-text-color)';
  }

  if (secondary) {
    textStyle.color = 'var(--background-secondary-text-color)';
  }

  if (primary) {
    textStyle.color = 'var(--background-text-color)';
  }

  if (textColor) {
    textStyle.color = textColor;
  }

  if (weight) {
    textStyle.fontWeight = weight;
  }

  if (props.textStyle) {
    textStyle = props.textStyle;
  }

  if (props.subtextStyle) {
    subtextStyle = { ...subtextStyle, ...props.subtextStyle };
  }

  if (align) {
    textContentStyle.alignItems = align;
  }

  if (justify) {
    textContentStyle.justifyContent = justify;
  }

  if (props.iconStyle) {
    iconStyle = props.iconStyle;
  }

  if (format) {
    classes = `${styles[format]} ` + classes;
  }

  if (!material) {
    iconStyle.height = 'auto';
    iconStyle.lineHeight = 1;
    iconStyle.minWidth = 20;
  }

  if (font) {
    elemStyle.fontFamily = font;
  }

  return (
    <div className={classes} style={elemStyle}>
      <FlexBox row align="center">
        {icon && !material && <Icon style={iconStyle} name={icon} />}
        {icon && material && (
          <div style={iconStyle} className={`${styles.materialIcon} material-icons`}>
            {icon}
          </div>
        )}
        <div className={`${styles.childContainer}`}>
          {(text || subtext) && (
            <FlexBox
              style={{ marginLeft: icon ? 5 : 0, padding: '0px 0px' }}
              justify={textContentStyle.justifyContent ? textContentStyle.justifyContent : undefined}
              align={textContentStyle.alignItems ? textContentStyle.alignItems : 'flex-start'}
              column
            >
              {text && (
                <div
                  style={textStyle}
                  className={`${styles.text} ${props.size && styles[props.size]} ${!icon ? styles.textOnly : ''}`}
                >
                  {text}
                </div>
              )}
              {subtext && (
                <div style={subtextStyle} className={styles.subtext}>
                  {subtext}
                </div>
              )}
            </FlexBox>
          )}
        </div>
      </FlexBox>
    </div>
  );
}

import PropTypes from 'prop-types';

FlexLabel.propTypes = {
  /** Custom styles to apply to the component */
  style: PropTypes.object,
  /** Flex value for the component */
  flex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Additional class name for the component */
  className: PropTypes.string,
  /** Whether to add gutter on all sides */
  guttered: PropTypes.bool,
  /** Format of the label */
  format: PropTypes.string,
  /** Size of the gutter in pixels */
  gutter: PropTypes.number,
  /** Whether to stretch vertically */
  vstretch: PropTypes.bool,
  /** Font family to use */
  font: PropTypes.string,
  /** Whether to stretch horizontally */
  hstretch: PropTypes.bool,
  /** Whether to add gutter on the right */
  rightGutter: PropTypes.bool,
  /** Whether to add gutter on the bottom */
  bottomGutter: PropTypes.bool,
  /** Whether to add gutter on the left */
  leftGutter: PropTypes.bool,
  /** Whether to add gutter on the top */
  topGutter: PropTypes.bool,
  /** Whether to fill the container height */
  fill: PropTypes.bool,
  /** Main text content */
  text: PropTypes.node,
  /** Secondary text content displayed below the main text */
  subtext: PropTypes.node,
  /** Icon name to display (for Semantic UI icons) */
  icon: PropTypes.string,
  /** Whether the icon is a material icon */
  material: PropTypes.bool,
  /** Alignment of the content */
  align: PropTypes.string,
  /** Justification of the content */
  justify: PropTypes.string,
  /** Whether to use primary styling */
  primary: PropTypes.bool,
  /** Whether to use secondary styling */
  secondary: PropTypes.bool,
  /** Whether to use tertiary styling */
  tertiary: PropTypes.bool,
  /** Font weight for the text */
  weight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Color for the text */
  textColor: PropTypes.string,
  /** Size of the label */
  size: PropTypes.string,
};

export default FlexLabel;
